import React, { useState } from 'react';
import {
    Box, Typography, Card, CardContent, Grid, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Button, Chip,
    TextField, MenuItem, Tabs, Tab, InputAdornment, Checkbox, Dialog,
    DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import {
    Search as SearchIcon, Download as DownloadIcon, Sms as SmsIcon,
    Email as EmailIcon, WhatsApp as WhatsAppIcon,
    CurrencyRupee as RupeeIcon, Warning as WarningIcon,
    NotificationsActive as NotifyIcon, Send as SendIcon,
    Print as PrintIcon
} from '@mui/icons-material';
import { toast } from 'react-toastify';

const FeeReminder = () => {
    const [tab, setTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [classFilter, setClassFilter] = useState('');
    const [selected, setSelected] = useState([]);
    const [sendDialog, setSendDialog] = useState(false);
    const [sendMode, setSendMode] = useState('sms');

    const students = [
        { id: 1, admNo: 'ADM001', name: 'Rohan Kulkarni', class: 'Class 9B', parentPhone: '9876543210', parentName: 'Suresh Kulkarni', totalDue: 42000, dueDate: '2026-01-15', overdueDays: 31, lastReminder: '2026-02-01', reminders: 2 },
        { id: 2, admNo: 'ADM002', name: 'Amit Singh', class: 'Class 7A', parentPhone: '9876543211', parentName: 'Prakash Singh', totalDue: 25000, dueDate: '2026-01-20', overdueDays: 26, lastReminder: '2026-02-05', reminders: 1 },
        { id: 3, admNo: 'ADM003', name: 'Sneha Sharma', class: 'Class 10A', parentPhone: '9876543212', parentName: 'Amit Sharma', totalDue: 10000, dueDate: '2026-02-01', overdueDays: 14, lastReminder: '-', reminders: 0 },
        { id: 4, admNo: 'ADM004', name: 'Diya Wagh', class: 'Class 5B', parentPhone: '9876543213', parentName: 'Sachin Wagh', totalDue: 18000, dueDate: '2025-12-15', overdueDays: 62, lastReminder: '2026-01-20', reminders: 3 },
        { id: 5, admNo: 'ADM005', name: 'Vikram Jadhav', class: 'Class 8A', parentPhone: '9876543214', parentName: 'Deepak Jadhav', totalDue: 35000, dueDate: '2026-01-01', overdueDays: 45, lastReminder: '2026-01-25', reminders: 2 },
        { id: 6, admNo: 'ADM006', name: 'Manasi Patil', class: 'Class 6B', parentPhone: '9876543215', parentName: 'Rajesh Patil', totalDue: 8000, dueDate: '2026-02-10', overdueDays: 5, lastReminder: '-', reminders: 0 },
    ];

    const filteredData = students.filter(s => {
        const matchTab = tab === 0 ? true : tab === 1 ? s.overdueDays > 30 : tab === 2 ? s.overdueDays <= 30 && s.overdueDays > 7 : s.overdueDays <= 7;
        const matchClass = !classFilter || s.class === classFilter;
        const matchSearch = !searchTerm || s.name.toLowerCase().includes(searchTerm.toLowerCase()) || s.admNo.toLowerCase().includes(searchTerm.toLowerCase());
        return matchTab && matchClass && matchSearch;
    });

    const totalPending = students.reduce((a, s) => a + s.totalDue, 0);
    const criticalCount = students.filter(s => s.overdueDays > 30).length;
    const moderateCount = students.filter(s => s.overdueDays <= 30 && s.overdueDays > 7).length;
    const recentCount = students.filter(s => s.overdueDays <= 7).length;

    const toggleSelect = (id) => {
        setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };
    const selectAll = () => setSelected(selected.length === filteredData.length ? [] : filteredData.map(s => s.id));

    const getOverdueColor = (days) => days > 30 ? 'error' : days > 7 ? 'warning' : 'info';

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <NotifyIcon sx={{ color: '#e53935', fontSize: 28 }} />
                    <Typography variant="h5" fontWeight={700}>Fee Reminder</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {selected.length > 0 && (
                        <>
                            <Button variant="contained" color="success" startIcon={<WhatsAppIcon />} size="small" onClick={() => { setSendMode('whatsapp'); setSendDialog(true); }}>WhatsApp ({selected.length})</Button>
                            <Button variant="contained" startIcon={<SmsIcon />} size="small" onClick={() => { setSendMode('sms'); setSendDialog(true); }}>SMS ({selected.length})</Button>
                            <Button variant="contained" color="info" startIcon={<EmailIcon />} size="small" onClick={() => { setSendMode('email'); setSendDialog(true); }}>Email ({selected.length})</Button>
                        </>
                    )}
                    <Button variant="outlined" startIcon={<PrintIcon />} size="small">Print List</Button>
                    <Button variant="outlined" startIcon={<DownloadIcon />} size="small">Export</Button>
                </Box>
            </Box>

            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #e53935' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary">Total Pending</Typography>
                            <Typography variant="h5" fontWeight={700} color="error.main">₹{(totalPending / 1000).toFixed(0)}K</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #e53935' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <WarningIcon sx={{ color: '#e53935', fontSize: 20 }} />
                            <Typography variant="body2" color="text.secondary">Critical (&gt;30 days)</Typography>
                            <Typography variant="h5" fontWeight={700}>{criticalCount}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #ff9800' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary">Moderate (7-30 days)</Typography>
                            <Typography variant="h5" fontWeight={700}>{moderateCount}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card sx={{ borderLeft: '4px solid #2196f3' }}>
                        <CardContent sx={{ py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary">Recent (&lt;7 days)</Typography>
                            <Typography variant="h5" fontWeight={700}>{recentCount}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Card>
                <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
                    <Tab label={`All (${students.length})`} />
                    <Tab label={`Critical (${criticalCount})`} />
                    <Tab label={`Moderate (${moderateCount})`} />
                    <Tab label={`Recent (${recentCount})`} />
                </Tabs>
                <Box sx={{ p: 2 }}>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth size="small" placeholder="Search by name or admission number..." value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField fullWidth select size="small" label="Class" value={classFilter} onChange={(e) => setClassFilter(e.target.value)}>
                                <MenuItem value="">All</MenuItem>
                                {[...new Set(students.map(s => s.class))].map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                            </TextField>
                        </Grid>
                    </Grid>

                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                    <TableCell padding="checkbox"><Checkbox checked={selected.length === filteredData.length && filteredData.length > 0} onChange={selectAll} /></TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Adm No.</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Student</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Class</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Parent / Phone</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>Due Amount</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Due Date</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Overdue</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Reminders</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Last Sent</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map(s => (
                                    <TableRow key={s.id} hover selected={selected.includes(s.id)} sx={{ bgcolor: s.overdueDays > 30 ? '#ffebee' : 'inherit' }}>
                                        <TableCell padding="checkbox"><Checkbox checked={selected.includes(s.id)} onChange={() => toggleSelect(s.id)} /></TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>{s.admNo}</TableCell>
                                        <TableCell>{s.name}</TableCell>
                                        <TableCell>{s.class}</TableCell>
                                        <TableCell><Typography variant="body2">{s.parentName}</Typography><Typography variant="caption" color="text.secondary">{s.parentPhone}</Typography></TableCell>
                                        <TableCell align="right" sx={{ color: '#e53935', fontWeight: 700 }}>₹{s.totalDue.toLocaleString()}</TableCell>
                                        <TableCell>{new Date(s.dueDate).toLocaleDateString()}</TableCell>
                                        <TableCell><Chip size="small" label={`${s.overdueDays} days`} color={getOverdueColor(s.overdueDays)} /></TableCell>
                                        <TableCell align="center">{s.reminders}</TableCell>
                                        <TableCell>{s.lastReminder}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Card>

            {/* Send Reminder Dialog */}
            <Dialog open={sendDialog} onClose={() => setSendDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Send Fee Reminder via {sendMode.toUpperCase()}</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Sending reminder to <strong>{selected.length}</strong> parent(s)
                    </Typography>
                    <TextField label="Message Template" fullWidth multiline rows={4} defaultValue={`Dear Parent,\n\nThis is a reminder that the school fees of ₹[amount] for your ward [student_name] is pending since [due_date]. Kindly pay at the earliest.\n\nRegards,\nVP School`} />
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setSendDialog(false)}>Cancel</Button>
                    <Button variant="contained" startIcon={<SendIcon />} onClick={() => { toast.success(`Reminders sent to ${selected.length} parent(s) via ${sendMode}`); setSendDialog(false); setSelected([]); }}>
                        Send {sendMode.toUpperCase()}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default FeeReminder;
